<template>
  <Transition :name="name" :mode="mode">
    <slot></slot>
  </Transition>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    default: 'defaultTransition'
  },
  mode: {
    type: String,
    default: 'out-in'
  }
})
</script>

<style lang="scss">
// 默认动效 淡出偏移
.defaultTransition-enter-active {
  transition: all 0.15s ease-in-out;
}
.defaultTransition-leave-active {
  transition: all 0.05s ease-in-out;
}

.defaultTransition-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}

.defaultTransition-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

// 优惠活动
.promotionsTransition-enter-active {
  transition: all 0.15s ease-in-out;
}
.promotionsTransition-leave-active {
  transition: all 0.05s ease-in-out;
}

.promotionsTransition-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.promotionsTransition-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

// 二级菜单
.bouncess-enter-active {
  animation: fadeInUps 0.5s;
}
.bouncess-leave-active {
  animation: fadeInUps 0.5s reverse;
}

@keyframes fadeInUps {
  0% {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
  }

  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
</style>
